import React from 'react';
import Button from 'components/ui/button';
import { useConnectAs } from 'hooks/use_connect_as';
import './connected_as_banner.scss';
import { useI18n } from 'hooks/use_i18n';

const ConnectedAsBanner = ({ children }) => {
  const { t } = useI18n();
  const { isConnectedAs, terminateSession } = useConnectAs();
  if (!isConnectedAs) {
    return children;
  }
  return (
    <div>
      <div className="connected-as-banner bg-danger">
        <p className="mb-0 font-weight-bold">
          {t('components.ui.connected_as_banner.session_handover')}
        </p>
        <Button
          size="tiny"
          outline
          color="light"
          onClick={() => terminateSession()}
        >
          {t('components.ui.connected_as_banner.end_handover')}
        </Button>
      </div>
      {children}
    </div>
  );
};

export default ConnectedAsBanner;
